import React, { useState } from "react";
import { useDispatch, useSelector } from "types/store";
import { Button } from "aible";
import { LineInput } from "@/components/Inputs/LineInput";
import * as contentGenerationReducer from "containers/ContentGeneration/reducer";
import { getSelectedFolder } from "containers/Folders/reducer";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";
import styles from "@/components/LanguageModelArtifact/style.module.css";
import { AibleClientFactory } from "@/client/aible/factory";
import { getSelectedAccountId } from "@/containers/Accounts/reducer";
import { sendPresignedRequest } from "@/utils/cloud/presigned_url";
const CreateCustomTrainingDataModal = ({ showModal, updateShowModal }) => {
    const dispatch = useDispatch();
    const currentDate = new Date().toLocaleString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
    });
    const trainingDataName = "New Training Data - " + currentDate;
    const [name, setName] = useState(trainingDataName);
    const [description, setDescription] = useState("");
    const [isCreatingData, updateIsCreatingData] = useState(false);
    const accountId = useSelector((state) => getSelectedAccountId(state));
    const folderId = useSelector((state) => getSelectedFolder(state));
    const handleCreateTrainingDataset = async (file) => {
        updateIsCreatingData(true);
        const exampleSetCreate = {
            name: name,
            description: description,
            metadata: {},
            folder_id: folderId
        };
        dispatch(contentGenerationReducer.createExampleSet(exampleSetCreate))
            .then((newExampleSet) => AibleClientFactory.getInstance()
            .getAccountClient()
            .getCustomerClientFactory(accountId)
            .then((client) => client.getContentGenerationClient().addCustomExampleSetData(newExampleSet.id))
            .catch((e) => {
            dispatch(contentGenerationReducer.deleteExampleSet(newExampleSet.id));
            throw e;
        }))
            .then((presigned) => sendPresignedRequest(file, presigned.url))
            .then(() => {
            updateShowModal(false);
        })
            .catch((e) => {
            console.log(e);
        })
            .finally(() => {
            updateIsCreatingData(false);
        });
    };
    return (React.createElement(Dialog, { open: showModal, onOpenChange: () => {
            updateShowModal(false);
        } },
        React.createElement(DialogContent, null,
            React.createElement(DialogHeader, null,
                React.createElement(DialogTitle, null, "Create a Custom Training Dataset")),
            React.createElement("div", null,
                React.createElement("div", { style: { marginBottom: "20px" } },
                    React.createElement("div", { style: { marginBottom: "5px" } }, "Evaluation Name"),
                    React.createElement(LineInput, { placeholder: "Evaluation Name", value: name, onChange: (value) => setName(value) })),
                React.createElement("div", null,
                    React.createElement("div", { style: { marginBottom: "5px" } }, "Evaluation Description"),
                    React.createElement("textarea", { className: styles.textArea, placeholder: "Evaluation Description", value: description, onChange: (e) => setDescription(e.target.value) }))),
            React.createElement(DialogFooter, null,
                React.createElement(Button, { onClick: () => {
                        document.getElementById("fUploadCustomExampleSet")?.click();
                    }, isLoading: isCreatingData }, "Create Training Dataset From File"),
                React.createElement("div", { style: { display: "none" } },
                    React.createElement("input", { type: "file", id: "fUploadCustomExampleSet", onChange: (e) => {
                            const file = e.currentTarget.files ? e.currentTarget.files[0] : undefined;
                            if (file !== undefined) {
                                handleCreateTrainingDataset(file);
                            }
                        } }))))));
};
export default CreateCustomTrainingDataModal;
